import React from 'react';
import classNames from 'classnames'
import 'intersection-observer';
import { useInView } from 'react-intersection-observer';
import { Col, Row, Container } from 'react-bootstrap';
import ImgBox from '@components/img-box/img-box';

/**
 * Assets
 */

import './styles/_index.scss';

/**
 * Components
 */
import NewsContactBox from '@components/contact-box/news-contact-box';
import Sidebar from '@components/sidebar/sidebar';
import NewsletterForm from '@components/forms/newsletter-form';
import ImageTransform from "@components/common/ggfx-client/module/components/image-transform";

import gql from "graphql-tag"
import { useQuery } from '@apollo/client';


function NewsWave(props) {

  //gitconsole.log("NewsWave" , data?.newsEvents[0]?.teams.length)
  const [ref, inView] = useInView({
    threshold: 0,
    triggerOnce: true,
  });


  return (
    <div className={`sidebar static-waves news-wave ${props?.teams?.length ? '' : 'no-show'}`}>

      <div className={classNames('news-wave', { 'is-active': inView })} ref={ref}>

        <div>
          {props?.teams && props?.teams?.map((team) => {
            return <>
              <NewsContactBox name={team?.Name} phone={team?.Phone} link="mailto:test@example.com" linkText="Email" teamimage={`${team?.Image?.publicURL}`} />
            </>
          })}
        </div>

      </div>

    </div>
  )
}

export default NewsWave
